import React, { useEffect, useRef } from "react";

const Hitechsolutions = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .solutions-container {
        width: 100%;
        padding: 40px 20px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .solutions-header {
        text-align: center;
        max-width: 900px;
        margin-bottom: 40px;
      }

      .solutions-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .solutions-subtitle {
        color: #555;
        font-size: 16px;
      }

      .solutions-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
        max-width: 1200px;
        width: 100%;
      }

      .solution-card {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        opacity: 0;
        transform: translateY(50px);
        transition: opacity 0.6s ease, transform 0.6s ease;
      }

      .solution-card.visible {
        opacity: 1;
        transform: translateY(0);
      }

      /* Random animations */
      .from-left { transform: translateX(-100px); }
      .from-right { transform: translateX(100px); }
      .from-bottom { transform: translateY(100px); }
      .from-top { transform: translateY(-100px); }

      .solution-card.visible.from-left,
      .solution-card.visible.from-right,
      .solution-card.visible.from-bottom,
      .solution-card.visible.from-top {
        transform: translateX(0) translateY(0);
        opacity: 1;
      }

      .solution-image {
        width: 100%;
        height: 200px;
        object-fit: cover;
        transition: transform 0.4s ease;
      }

      .solution-card:hover .solution-image {
        transform: scale(1.1);
      }

      .solution-content {
        padding: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .solution-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }

      .solution-desc {
        font-size: 14px;
        color: #444;
        line-height: 1.6;
      }

      /* Responsiveness */
      @media (max-width: 1024px) {
        .solutions-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      @media (max-width: 600px) {
        .solutions-grid {
          grid-template-columns: 1fr;
        }
      }
    `;
    document.head.appendChild(style);

    const cards = containerRef.current.querySelectorAll(".solution-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    const directions = ["from-left", "from-right", "from-top", "from-bottom"];
    cards.forEach((card) => {
      const randomClass =
        directions[Math.floor(Math.random() * directions.length)];
      card.classList.add(randomClass);
      observer.observe(card);
    });

    return () => {
      document.head.removeChild(style);
      observer.disconnect();
    };
  }, []);

  const solutions = [
    {
      img: "/image/software-product-innovation-services-web_Small.jpg",
      title: "Software Product Innovation",
      desc: "Accelerating product development with agile methodologies, modern architectures, and next-gen software platforms."
    },
    {
      img: "/image/Shape the Future with AI.png",
      title: "Shape the Future with AI",
      desc: "Building intelligent systems that redefine user experiences, optimize processes, and create smarter digital ecosystems."
    },
    {
      img: "/image/Harness the Power of Data & Analytics.jpg",
      title: "Harness the Power of Data & Analytics",
      desc: "Transforming raw data into actionable insights through big data platforms, predictive analytics, and real-time dashboards."
    },
    {
      img: "/image/Generative AI in Software Industry.webp",
      title: "Generative AI in Software Industry",
      desc: "Revolutionizing creativity and automation in software development, content creation, and business intelligence."
    },
    {
      img: "/image/Next-Gen Cybersecurity.webp",
      title: "Next-Gen Cybersecurity",
      desc: "Strengthening digital trust with AI-driven threat detection, zero-trust security models, and cloud-native protection."
    },
    {
      img: "/image/Cloud & Edge Computing.jpg",
      title: "Cloud & Edge Computing",
      desc: "Delivering scalable, resilient, and intelligent infrastructures with hybrid cloud, edge processing, and serverless solutions."
    }
  ];

  return (
    <div className="solutions-container" ref={containerRef}>
      <div className="solutions-header">
        <h2 className="solutions-title">High-Tech Industry Solutions</h2>
        <p className="solutions-subtitle">
          Driving the digital future with AI, cloud, cybersecurity, and innovative software solutions to power global enterprises.
        </p>
      </div>

      <div className="solutions-grid">
        {solutions.map((item, index) => (
          <div className="solution-card" key={index}>
            <img src={item.img} alt={item.title} className="solution-image" />
            <div className="solution-content">
              <h3 className="solution-title">{item.title}</h3>
              <p className="solution-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hitechsolutions;
